/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { formatDate } from '../../utils/date';


const PhaseColumn = (phase) => {

  return phase.stages.map((stage, j) => {
    let completed = [];
    let utrs = [];
    return (
      <th key={stage._id} className={completed.length > 0 ? (completed.length < utrs.length ? 'in-progress' : 'completed') : ''}>
        <b>{stage.name}</b>

        <div className='row mt-xs'>
          <div className='col-6'>
            Start<br />
            {formatDate(stage.startDate)}
          </div>

          <div className='col-6'>
            End<br />
            {formatDate(stage.endDate)}
          </div>

        </div>

      </th>

    )
  })
};

export default PhaseColumn;
